module.exports = __webpack_public_path__ + "static/media/Write-Article-on-Top-Cash-for-Cars-Brisbane.040954a3.jpg";